import {
  IKpiRepository,
  KpiEntity,
  ResponseValueObject,
} from '@gishub/domain';

export class KpiRepository implements IKpiRepository {
  async getKpiDefs(): Promise<ResponseValueObject<KpiEntity[]>> {
    return new ResponseValueObject(true, [
      { key: 'comunidades', label: 'Comunidades registradas', unit: '' },
      { key: 'espacios', label: 'Espacios de diálogo', unit: '' },
      { key: 'compromisos', label: 'Compromisos', unit: '' },
      { key: 'intervenciones', label: 'Intervenciones', unit: '' },
      { key: 'areaAgricola', label: 'Superficie agrícola', unit: 'ha' },
      { key: 'anp', label: 'Cobertura ANP', unit: 'ha' },
      { key: 'obras', label: 'Obras activas', unit: '' },
      { key: 'poblacion', label: 'Población estimada', unit: '' },
      { key: 'riesgo', label: 'Riesgo territorial', unit: '' },
    ]);
  }
}
